import { action, computed, makeObservable, observable } from "mobx";
import { UserRole } from "../helpers/userRole";

export interface UserStore {
    username?: string;
    setUsername: (username?: string) => void;

    sessionId?: string;
    setSessionId: (sessionId?: string) => void;

    roles?: UserRole[];
    setRoles: (roles?: UserRole[]) => void;
}

export class DefaultUserStore implements UserStore {
    constructor() {
        makeObservable(this);
    }

    @computed
    public get username() {
        return this._username;
    }

    @computed
    public get sessionId() {
        return this._sessionId;
    }

    @computed
    public get roles() {
        return this._roles;
    }

    @observable
    private _username?: string;

    @observable
    private _sessionId?: string;

    @observable
    private _roles?: UserRole[];

    @action
    public setUsername(username?: string) {
        this._username = username;
    }

    @action
    public setSessionId(sessionId?: string) {
        this._sessionId = sessionId;
    }

    @action
    public setRoles(roles?: UserRole[]) {
        this._roles = roles;
    }
}
